import type { ComponentProps, ReactNode } from 'react';
import { Component } from 'react';
import { ErrorPage } from './ErrorPage';
import type { ErrorPageProps } from './ErrorPage';

type ErrorBoundaryProps = Omit<ErrorPageProps, 'error'> & {
  children: ReactNode;
};

type ErrorBoundaryState = {
  error: Error | null;
};

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ComponentProps<any>) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { error: error };
  }

  render() {
    const { children, message } = this.props;
    const { error } = this.state;
    if (this.state.error) {
      return <ErrorPage error={error} message={message} />;
    }
    return <>{children}</>;
  }
}
